quoteModule.factory('rateQuoteCoordService',
['$http','$window','AppSettings', 'commonRESTCallService', '$q','rateQuoteScenariosService',
    'CustomerInfo','DealInfo','LenderInfo','VehicleInfo', 'quoteIntegrationConstants',
function (
$http, $window, appSettings, commonRESTCallService, $q, rateQuoteScenariosService,
    CustomerInfo, DealInfo, LenderInfo, VehicleInfo, quoteIntegrationConstants) {
    var rateQuoteCoordService = {};

    //-----------------------------------------
    // this service keeps up with all of the quotes
    // the user has created or copied, including
    // multiple "quote groups", called scenarios
    //-----------------------------------------
    var _heldQuotesPerProposal = [];
    //var _quoteSession = null;

    var _myVehicleData = null;
    var _myProviderData = null;

    rateQuoteCoordService.getQuotingMode = function() {
        return $window.sessionStorage.getItem('SESS_QUOTE_MODE');
    };
    rateQuoteCoordService.CustomerData = new CustomerInfo();
    rateQuoteCoordService.DealData = new DealInfo();
    //COM-808 new field for keeping track of "retrieved" deal information (from DB)
    rateQuoteCoordService.RetrievedDealData = new DealInfo();
    rateQuoteCoordService.LenderData = {
        options: [],
        selectedLender: new LenderInfo(),
        notApplicableLender: null   // Specific lender that explicitly indicates "No Lender", rather than no lender selected.
    };
    rateQuoteCoordService.VehicleData = new VehicleInfo();

    _heldQuotesPerProposal[rateQuoteScenariosService.getCurrentScenario()] = [];

    rateQuoteCoordService.initHeldQuotes = function() {
        for(var i = 0; i < _heldQuotesPerProposal.length; i++) {
            _heldQuotesPerProposal[i] = [];
        }
    };
    //
    rateQuoteCoordService.getHeldQuotesPerProposal = function() {
        return _heldQuotesPerProposal;
    }
    //initialize customer data
    rateQuoteCoordService.clearCustomer = function(){ rateQuoteCoordService.CustomerData = new CustomerInfo(); };
    //initialize deal data
    rateQuoteCoordService.clearDeal = function(){ rateQuoteCoordService.DealData = new DealInfo(); };
    //initialize lender data
    rateQuoteCoordService.clearLender = function(){
        rateQuoteCoordService.LenderData.selectedLender = this.LenderData.notApplicableLender || new LenderInfo();
    };
    //initialize vehicle data
    rateQuoteCoordService.clearVehicle = function(){ rateQuoteCoordService.VehicleData = new VehicleInfo(); }
    //clear all customer data (when switching between search, dms retrieval, "new", etc.)
    rateQuoteCoordService.clearAll = function(){
        rateQuoteCoordService.clearVehicle();
        rateQuoteCoordService.clearLender();
        rateQuoteCoordService.clearDeal();
        rateQuoteCoordService.clearCustomer();
    }
    //clear up saved quote/rate data
    rateQuoteCoordService.startNewQuoteSession = function (clearDeal, clearCustomer, clearVehicle, clearLender) {
        var deferred = $q.defer();

        _heldQuotesPerProposal = [];
        rateQuoteScenariosService.setCurrentScenario(1);
        _heldQuotesPerProposal[rateQuoteScenariosService.getCurrentScenario] = [];

        rateQuoteScenariosService.startFirstQuoteScenario();

        if (clearCustomer) {
            rateQuoteCoordService.clearCustomer();
        }
        if (clearDeal) {
            rateQuoteCoordService.clearDeal();
        }
        if (clearVehicle) {
            _myVehicleData = null;
        }
        if (clearLender){
            rateQuoteCoordService.clearLender();
        }

        deferred.resolve(true);

        return deferred.promise;
    }
    //get the quotes for a proposal code
    rateQuoteCoordService.getQuotesByScenarioId = function(scenarioId){
        return _heldQuotesPerProposal[scenarioId] == undefined ? null : _heldQuotesPerProposal[scenarioId];
    }
    //"product scenarios" lists
    rateQuoteCoordService.getQuoteSessionId = function () {
        var val = $window.sessionStorage.getItem('SESS_QUOTE_SESSION_NUM');
        return val;
    }
    //set the session (from saved quotes)
    rateQuoteCoordService.setQuoteSessionId = function(id){
        $window.sessionStorage.setItem('SESS_QUOTE_SESSION_NUM',id);
        return;
    }
    //provider specific data for saving the rates as quotes
    // we assume the deal data is validated at this point
    rateQuoteCoordService.captureProviderData = function (data) {
        _myProviderData = data;
    }
    //return the provider data for the quote
    rateQuoteCoordService.getCapturedProviderData = function () {
        return _myProviderData;
    }
    //return rates for a scenario (for copying)
    rateQuoteCoordService.getRatesForScenarioCode = function (scenarioCode) {
        if (!scenarioCode){
            return _heldQuotesPerProposal;
        }
        else if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioCode) >= 0) {
            return _heldQuotesPerProposal[scenarioCode];
        }
        return null;
    }
    //return the rate for a proposal and product identifier
    rateQuoteCoordService.getRateForScenarioCodeProductId = function(scenarioCode, productInternalId){
        if (!productInternalId)
            return null;
        if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioCode) >= 0) {
            var foundQuoteIdx = -1;
            for (var i = 0; _heldQuotesPerProposal[scenarioCode] && i < _heldQuotesPerProposal[scenarioCode].length && foundQuoteIdx < 0; i++) {
                if (_heldQuotesPerProposal[scenarioCode][i] && _heldQuotesPerProposal[scenarioCode][i].RatedProduct && _heldQuotesPerProposal[scenarioCode][i].RatedProduct.InternalProductId.toUpperCase() == productInternalId.toUpperCase()) {
                    foundQuoteIdx = i;
                }
            }
            if (foundQuoteIdx >= 0)
                return _heldQuotesPerProposal[scenarioCode][foundQuoteIdx];
            else
                return null;
        }
        else
            return null;
    }
    //return the rate for a proposal and product type
    rateQuoteCoordService.getRateForScenarioCodeProductType = function(scenarioCode, productType){
        if (!productType)
            throw new Error('Product type not provided.');
        if (!scenarioCode)
            throw new Error('Scenario code not provided.');

        if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioCode) >= 0) {
            var foundQuoteIdx = -1;
            for (var i = 0; _heldQuotesPerProposal[scenarioCode] && i < _heldQuotesPerProposal[scenarioCode].length && foundQuoteIdx < 0; i++) {
                var pCat = _heldQuotesPerProposal[scenarioCode][i].RatedProduct.ParentProductType.ParentProductRatingCategory;
                var pCatRateType = getRatedProductCatFlexField(pCat,'COMMERCE-RATE-TYPE') ? getRatedProductCatFlexField(pCat,'COMMERCE-RATE-TYPE') : pCat.ApplicationCode;

                if (_heldQuotesPerProposal[scenarioCode][i] && _heldQuotesPerProposal[scenarioCode][i].RatedProduct &&
                    pCatRateType == productType.toUpperCase()) {
                    foundQuoteIdx = i;
                }
            }
            if (foundQuoteIdx >= 0)
                return _heldQuotesPerProposal[scenarioCode][foundQuoteIdx];
            else
                return null;
        }
        else
            return null;
    }

    var getRatedProductCatFlexField = function(productCat, fieldName) {
        var flexFields = productCat
            && productCat.PartnerSpecificFields
            && productCat.PartnerSpecificFields.FlexFields
            && productCat.PartnerSpecificFields.FlexFields;

        if (!angular.isArray(flexFields))
            return angular.undefined;

        var field = _.find(flexFields, function (fieldObj) { return fieldObj.FieldName == fieldName});

        return field && field.FieldValue;
    }

    //create/copy a new scenario
    rateQuoteCoordService.addNewScenario = function (copyScenarioNum) {
        var maxScenario = rateQuoteScenariosService.getScenarioList()[rateQuoteScenariosService.getScenarioList().length-1];
        var nxtScenario = maxScenario + 1;
        rateQuoteScenariosService.addNewScenario(nxtScenario);

        if (copyScenarioNum &&
            rateQuoteScenariosService.getScenarioList().indexOf(copyScenarioNum) >= 0 &&
            rateQuoteCoordService.getQuotesByScenarioId(copyScenarioNum) &&
            rateQuoteCoordService.getQuotesByScenarioId(copyScenarioNum).length > 0) {
            var copiedQuoteScenarios = angular.copy(_heldQuotesPerProposal[copyScenarioNum]);
            copiedQuoteScenarios.forEach(function (copiedQuote) {
                copiedQuote.RatedTerms[0].SavedRateUniqueId = '';
                copiedQuote.RatedTerms[0].SavedRateScnearioId = nxtScenario;
                copiedQuote.RatedTerms[0].SavedRateSessionId = rateQuoteCoordService.getQuoteSessionId();
            });
            if (copiedQuoteScenarios)
                _heldQuotesPerProposal[nxtScenario]=copiedQuoteScenarios;
            else
                _heldQuotesPerProposal[nxtScenario]=[];
        } else {
            _heldQuotesPerProposal[nxtScenario]=[];
        }

        return nxtScenario;
    }
    //hold a rate for saving later
    rateQuoteCoordService.holdRateForQuote = function (rate, scenarioCode, cachedProdResponseId, cachedRateResponseId) {

        //var ratingCategory = rate.RatedProduct.ParentProductType.ParentProductRatingCategory.ApplicationCode.toUpperCase();
        var pCategory = rate.RatedProduct.ParentProductType.ParentProductRatingCategory;
        var ratingCategory = getRatedProductCatFlexField(pCategory,'COMMERCE-RATE-TYPE') ? getRatedProductCatFlexField(pCategory,'COMMERCE-RATE-TYPE') : pCategory.ApplicationCode;

        if (!ratingCategory) {
            throw new Error("Could not find rating category");
        }
        //see if we have this product scenario yet
        if (_heldQuotesPerProposal[scenarioCode] == null) {
            _heldQuotesPerProposal[scenarioCode] = [];
            rateQuoteScenariosService.addNewScenarioNoCopy(scenarioCode);
        }
        //see if we have this product category yet
        var foundQuoteIdx = -1;
        for (var i = 0; i < _heldQuotesPerProposal[scenarioCode].length && foundQuoteIdx < 0; i++) {
            var nxtCategory = _heldQuotesPerProposal[scenarioCode][i].RatedProduct.ParentProductType.ParentProductRatingCategory;

            var nxtRatingCategory = getRatedProductCatFlexField(nxtCategory,'COMMERCE-RATE-TYPE') ? getRatedProductCatFlexField(nxtCategory,'COMMERCE-RATE-TYPE') : nxtCategory.ApplicationCode;
            if (nxtRatingCategory == ratingCategory) {
                foundQuoteIdx = i;
            }
        }
        var holdRateId = null;
        var holdRateSessionId = null;

        if (foundQuoteIdx >= 0) {
            var rateToRemove = _heldQuotesPerProposal[scenarioCode][foundQuoteIdx];
            if (rateToRemove.RatedTerms[0].SavedRateUniqueId) {
                holdRateId = rateToRemove.RatedTerms[0].SavedRateUniqueId;
                holdRateSessionId = rateToRemove.RatedTerms[0].SavedRateSessionId;
            }
            _heldQuotesPerProposal[scenarioCode].splice(foundQuoteIdx, 1);
        }
        //push the rate
        rate.RatedTerms[0].SavedRateUniqueId = holdRateId ? holdRateId : rate.RatedTerms[0].SavedRateUniqueId;
        rate.RatedTerms[0].SavedRateSessionId = holdRateSessionId ? holdRateSessionId : rate.RatedTerms[0].SavedRateSessionId;
        rate.RatedTerms[0].SavedRateScenarioId = scenarioCode;
        rate.cachedProductResponseId = cachedProdResponseId;
        rate.cachedRateResponseId = cachedRateResponseId;
        _heldQuotesPerProposal[scenarioCode].push(rate);
    }
    //update the integration data by token
    rateQuoteCoordService.getNewGuid = function (inQuoteRetrieval) {
        var deferred = $q.defer();

        //if we are retrieving quotes for contracting (menu integrated), we
        // don't want to reset the quote guid.. it was set via the "qsession" query string
        // so just take it as is
        if (rateQuoteCoordService.getQuotingMode() == quoteIntegrationConstants.menuContractIntegrated ||
            inQuoteRetrieval
            )
            deferred.resolve(rateQuoteCoordService.getQuoteSessionId());
        else {
            var url = appSettings.startSPANPlusSvcURL + "productquotes/newquoteguid";
            commonRESTCallService.getFromServer(url)
                .success(function (data, status) {
                    rateQuoteCoordService.setQuoteSessionId(data);
                    deferred.resolve(data);
                })
                .error(function (data, status) {
                    rateQuoteCoordService.setQuoteSessionId(null);
                    deferred.reject(status + ' ' + data);
                });
        }

        return deferred.promise;
    }
    //serve up the "held" rates/quotes for a scenario id
    rateQuoteCoordService.getQuotesForScenario = function(scenarioID){
        if (rateQuoteScenariosService.getScenarioList().indexOf(scenarioID) < 0){
            throw new Error("scenario id not valid");
        }

        return _heldQuotesPerProposal[scenarioID];
    }

    return rateQuoteCoordService;
}]);
